import {
	IModel,
	IVIPCompanyBase,
	VIPCompanyBase,
} from "@/loader";

/**
 * Company Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPCompany extends IVIPCompanyBase {
	logo?: string;
}

/**
 * Company Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPCompany extends VIPCompanyBase implements IVIPCompany, IModel<IVIPCompany> {
	public logo!: string;

	constructor (data: IVIPCompany = {}) {
		super(data);
	}

	public load(data: IVIPCompany) {
		super.load(data);
		this.logo = String.orDefault(data.logo);
	}

	public update(data: IVIPCompany) {
		super.update(data);
		if ("logo" in data) {
			this.logo = String.orDefault(data.logo);
		}
	}

	public get address(): string {
		return [
			this.address1,
			this.address2,
			((this.zipcode || "") + " " + (this.city || "")).trim(),
			this.country !== "France" ? this.country : null
		].filter(x => !!x).join("\n").trim();
	}

	public get addressOneLine(): string {
		return [
			this.address1,
			this.address2,
			((this.zipcode || "") + " " + (this.city || "")).trim(),
			this.country !== "France" ? this.country : null
		].filter(x => !!x).join(", ").trim();
	}

	public toString(): string {
		return `${this.name} - ${this.city}`;
	}
}
